import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import WorkerEditForm from './WorkerEditForm';
import WorkerList from './WorkerList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import WorkerListView from './WorkerListView'


export default function WorkerDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.manufslice.workerDashboard);
  const [ workerId, setWorkerId] = React.useState('');
  const [reloadWorkerList, setReloadWorkerList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <WorkerEditForm 
            setReloadWorkerList={setReloadWorkerList}
            workerId={workerId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <WorkerListView 
                      setWorkerId = {setWorkerId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
